import { render, staticRenderFns } from "./regionCompare_dis.vue?vue&type=template&id=864a347e"
import script from "./regionCompare_dis.vue?vue&type=script&lang=js"
export * from "./regionCompare_dis.vue?vue&type=script&lang=js"
import style0 from "./regionCompare_dis.vue?vue&type=style&index=0&id=864a347e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports